<template>
  <ul
    role="list"
    aria-live="polite"
    class="brand-password-requirements pa-0 ma-0 mt-2"
  >
    <li
      v-for="rule in rules"
      :key="rule.key"
      class="d-flex align-center text-caption mb-1"
      :class="rule.satisfied ? 'text-mint600' : 'text-orange400'"
    >
      <component
        :is="rule.satisfied ? PhCheckCircle : PhCircle"
        :weight="rule.satisfied ? 'fill' : 'regular'"
        class="mr-2"
        aria-hidden="true"
      />
      <span>{{ rule.label }}</span>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { PhCheckCircle, PhCircle } from '@phosphor-icons/vue'
import { PASSWORD_REQUIREMENTS } from '@/utils/form-rules'

defineOptions({
  name: 'BrandPasswordRequirements',
})

const props = defineProps({
  password: {
    type: String,
    default: '',
  },
})

const { t } = useI18n()

const rules = computed(() =>
  PASSWORD_REQUIREMENTS.map(req => ({
    key: req.key,
    satisfied: req.test(props.password),
    label: t(`form.password_requirements.${req.key}`, req.params ?? {}),
  }))
)
</script>

<style lang="scss" scoped>
.brand-password-requirements {
  list-style: none;
}
</style>
